import { Directive, HostBinding } from '@angular/core';

@Directive({
  selector: '[evkMatDisplay2]'
})
export class MatDisplay2Directive {

    @HostBinding('class')
    public class = 'mat-display-2';

    @HostBinding('style.margin')
    public margin = 0;
}
